import { render, staticRenderFns } from "./BultenKategoriTanimlama.vue?vue&type=template&id=42857348&scoped=true&"
import script from "./BultenKategoriTanimlama.vue?vue&type=script&lang=js&"
export * from "./BultenKategoriTanimlama.vue?vue&type=script&lang=js&"
import style0 from "./BultenKategoriTanimlama.vue?vue&type=style&index=0&id=42857348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42857348",
  null
  
)

export default component.exports